import startCase from "lodash/startCase";
import camelCase from "lodash/camelCase";

export function formatTitle(input: string): string {
  return startCase(camelCase(input));
}
